module.exports = __webpack_public_path__ + "static/media/halfcircle_blue.bc6b5ca0.jpg";